export const callbacks:{
    onWs?:(ws: WebSocket) =>void
    onCustomMsg?:(data: any) =>void
} = {
    onWs: undefined,
    onCustomMsg: undefined,
}